import React from "react";
import { hydrate, render } from "react-dom";

import "./index.css";
import App from "./App";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-KLLJV4X"
};

const rootElement = document.getElementById("root");

TagManager.initialize(tagManagerArgs);

if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}



// WEBPACK FOOTER //
// ./src/index.js